import React, { useState, useMemo, useEffect } from 'react';
import PocketBase from 'pocketbase';

const pb = new PocketBase('https://bahcarplaza.com');

const ALL_BRANDS = ['Maruti Suzuki', 'Hyundai', 'Honda', 'Tata', 'Mahindra', 'Toyota', 'KIA', 'Ford', 'Volkswagen', 'BMW', 'Mercedes Benz'];
const BRAND_LOGOS = {
  'Maruti Suzuki': 'https://i.pinimg.com/1200x/f1/04/16/f1041698a90aea121f8da53acf1a8f92.jpg',
  'Hyundai': 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Hyundai_Motor_Company_logo.svg/2048px-Hyundai_Motor_Company_logo.svg.png',
  'Honda': 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Honda_Logo.svg/2048px-Honda_Logo.svg.png',
  'Tata': 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Tata_logo.svg/2048px-Tata_logo.svg.png',
  'Mahindra': 'https://i.pinimg.com/1200x/17/38/ff/1738ff204f7eaaf912742070a0871f8e.jpg',
  'Toyota': 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Toyota_carlogo.svg/2048px-Toyota_carlogo.svg.png',
  'KIA': 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/KIA_logo2.svg/2048px-KIA_logo2.svg.png',
  'Ford': 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Ford_Motor_Company_Logo.svg/2048px-Ford_Motor_Company_Logo.svg.png',
  'Volkswagen': 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Volkswagen_logo_2019.svg/2048px-Volkswagen_logo_2019.svg.png',
  'BMW': 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/BMW.svg/2048px-BMW.svg.png',
  'Mercedes Benz': 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Mercedes-Logo.svg/2048px-Mercedes-Logo.svg.png',
};

// 🚨 BODY TYPES 🚨
const BODY_TYPES = [
  { name: 'Hatchback', icon: <svg viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full"><path d="M15 35H85C87.7614 35 90 32.7614 90 30V25C90 22.2386 87.7614 20 85 20H15C12.2386 20 10 22.2386 10 25V30C10 32.7614 12.2386 35 15 35Z" fill="#9CA3AF"/><path d="M30 20L35 10H75L80 20H30Z" fill="#D1D5DB"/><circle cx="25" cy="35" r="8" fill="#374151"/><circle cx="75" cy="35" r="8" fill="#374151"/><circle cx="25" cy="35" r="4" fill="#F3F4F6"/><circle cx="75" cy="35" r="4" fill="#F3F4F6"/><path d="M12 25H16V28H12V25Z" fill="#FCD34D"/></svg> },
  { name: 'Sedan', icon: <svg viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full"><path d="M10 35H90C92.7614 35 95 32.7614 95 30V25C95 22.2386 92.7614 20 90 20H10C7.23858 20 5 22.2386 5 25V30C5 32.7614 7.23858 35 10 35Z" fill="#60A5FA"/><path d="M25 20L35 10H65L75 20H25Z" fill="#93C5FD"/><circle cx="25" cy="35" r="8" fill="#1E3A8A"/><circle cx="75" cy="35" r="8" fill="#1E3A8A"/><circle cx="25" cy="35" r="4" fill="#DBEAFE"/><circle cx="75" cy="35" r="4" fill="#DBEAFE"/><path d="M7 25H11V28H7V25Z" fill="#FCD34D"/><path d="M89 25H93V28H89V25Z" fill="#F87171"/></svg> },
  { name: 'SUV', icon: <svg viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full"><path d="M15 40H85C87.7614 40 90 37.7614 90 35V20C90 17.2386 87.7614 15 85 15H15C12.2386 15 10 17.2386 10 20V35C10 37.7614 12.2386 40 15 40Z" fill="#34D399"/><path d="M25 15L30 5H85L90 15H25Z" fill="#6EE7B7"/><circle cx="25" cy="40" r="10" fill="#064E3B"/><circle cx="75" cy="40" r="10" fill="#064E3B"/><circle cx="25" cy="40" r="5" fill="#D1FAE5"/><circle cx="75" cy="40" r="5" fill="#D1FAE5"/><path d="M12 25H16V30H12V25Z" fill="#FCD34D"/><rect x="35" y="15" width="30" height="25" fill="#10B981"/></svg> },
  { name: 'MUV', icon: <svg viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full"><path d="M10 40H90C92.7614 40 95 37.7614 95 35V15C95 12.2386 92.7614 10 90 10H10C7.23858 10 5 12.2386 5 15V35C5 37.7614 7.23858 40 10 40Z" fill="#A78BFA"/><circle cx="25" cy="40" r="9" fill="#4C1D95"/><circle cx="75" cy="40" r="9" fill="#4C1D95"/><circle cx="25" cy="40" r="4" fill="#EDE9FE"/><circle cx="75" cy="40" r="4" fill="#EDE9FE"/><path d="M7 25H11V30H7V25Z" fill="#FCD34D"/><rect x="25" y="15" width="20" height="20" fill="#C4B5FD"/><rect x="55" y="15" width="20" height="20" fill="#C4B5FD"/></svg> }
];

function MobileBuyCar({ view, setView, goBack, cars = [], searchTerm = "", setSearchTerm, cityFilter, setCityFilter, setSelectedCar }) {
  const [subView, setSubView] = useState('main'); 
  const [listConfig, setListConfig] = useState({ type: 'all', brand: '', bodyType: '', title: 'All Cars' });
  const [showBrandsSheet, setShowBrandsSheet] = useState(false);
  const [showSortSheet, setShowSortSheet] = useState(false);
  const [showFilterSheet, setShowFilterSheet] = useState(false);
  const [showTestDriveModal, setShowTestDriveModal] = useState(false);
  const [activeRecDot, setActiveRecDot] = useState(0);
  const [activeBudgetDot, setActiveBudgetDot] = useState(0);
  const [activeSoldDot, setActiveSoldDot] = useState(0);
  const [imageDotIndex, setImageDotIndex] = useState({});
  const [sortBy, setSortBy] = useState('Relevance');
  const [priceRange, setPriceRange] = useState({ min: 0, max: 7000000 });
  const [selectedBrandsFilter, setSelectedBrandsFilter] = useState([]);
  const [selectedBodyTypeFilter, setSelectedBodyTypeFilter] = useState([]); 
  const [kmDrivenFilters, setKmDrivenFilters] = useState([]); 
  const [fuelFilters, setFuelFilters] = useState([]);
  const [transmissionFilters, setTransmissionFilters] = useState([]);
  const [ownerFilters, setOwnerFilters] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  
  // 🚨 Test Drive User Data State 🚨
  const [testDriveData, setTestDriveData] = useState({ full_name: '', phone: '', booking_date: '', message: '' });

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const safeCarsArray = Array.isArray(cars) ? cars : [];
  const getVal = (val) => (Array.isArray(val) ? val[0] : val || "");
  const extractUniqueValues = (key, isArrayFormat = false) => {
    const values = safeCarsArray.map(car => isArrayFormat ? getVal(car[key]) : car[key]).filter(val => val && typeof val === 'string' && val.trim() !== "");
    return [...new Set(values)];
  };

  const dynamicCities = useMemo(() => extractUniqueValues('city', true), [safeCarsArray]);
  const dynamicFuels = useMemo(() => extractUniqueValues('fuel_type', true), [safeCarsArray]);
  const dynamicTransmissions = useMemo(() => extractUniqueValues('transmission', true), [safeCarsArray]);
  const dynamicOwners = useMemo(() => extractUniqueValues('owner_type'), [safeCarsArray]);

  useEffect(() => {
    if (searchTerm === 'HOT_DEALS') {
      openListView('hot_deal', '', '', '🔥 Super Hot Deals');
      setSearchTerm(''); 
    } else if (searchTerm === 'LESS_DRIVEN') {
      openListView('less_driven', '', '', 'Less Driven Cars');
      setSearchTerm('');
    } else if (searchTerm === 'HIGH_MILEAGE') {
      openListView('high_mileage', '', '', 'High Mileage Cars');
      setSearchTerm('');
    } else if (searchTerm.startsWith('BODY_TYPE_')) {
      const bType = searchTerm.replace('BODY_TYPE_', '');
      openListView('bodyType', '', bType, `${bType} Cars`);
      setSearchTerm('');
    } else if (searchTerm) {
      const isBodyType = BODY_TYPES.find(b => b.name.toLowerCase() === searchTerm.toLowerCase());
      if (isBodyType) {
        openListView('bodyType', '', isBodyType.name, `${isBodyType.name} Cars`);
      } else {
        openListView('brand', searchTerm, '', `${searchTerm} Cars`);
      }
    }
  }, [searchTerm, setSearchTerm]);

  useEffect(() => {
    const handlePopState = (event) => {
      if (subView === 'list') {
        if (!event.state || event.state.subView !== 'list') {
          setSubView('main');
          setSearchTerm(""); 
        }
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [subView, setSearchTerm]);

  const openListView = (type, brand = '', bodyType = '', title = '') => { 
    setListConfig({ type, brand, bodyType, title }); 
    setSubView('list'); 
    window.scrollTo(0, 0); 
    window.history.pushState({ page: 'buy', subView: 'list' }, '');
  };

  const handleCustomBack = () => {
    if (subView === 'list') {
      window.history.back(); 
    } else {
      goBack(); 
    }
  };

  // 🚨 AUTO FILL TEST DRIVE DATA WHEN MODAL OPENS 🚨
  const openTestDriveModal = () => {
    if (pb.authStore.isValid) {
      setTestDriveData({
        ...testDriveData,
        full_name: pb.authStore.model.name || '',
        phone: pb.authStore.model.phone || ''
      });
    }
    setShowTestDriveModal(true);
  };

  const getImages = (val) => Array.isArray(val) ? val : (val ? [val] : []);
  const calculateEMI = (price) => Math.round((Number(price) || 0) * 0.015).toLocaleString();

  const handleAddToWishlist = async (e, carId) => {
    e.stopPropagation();
    if (!pb.authStore.isValid) return alert("Please log in to add to wishlist.");
    try { await pb.collection('wishlist').create({ user_id: pb.authStore.model?.id, car_id: carId }); alert("Added to Wishlist! ❤️"); } 
    catch (e) { alert("Already in wishlist or error occurred."); }
  };

  const handleBuyNow = (e, car) => {
    e.stopPropagation();
    if (!pb.authStore.isValid) { alert("Please login to buy."); setView('auth'); return; }
    setSelectedCar(car); setView('checkout_page'); 
  };

  const handleTestDriveSubmit = async (e) => {
    e.preventDefault();
    if (!pb.authStore.isValid) return alert("Please login first.");
    try {
      await pb.collection('bookings').create({ 
        ...testDriveData, 
        phone: testDriveData.phone.toString(), 
        booking_date: new Date(testDriveData.booking_date).toISOString(), 
        visit_type: 'Test Drive', 
        status: 'Pending', 
        user_id: pb.authStore.model?.id,
        // Since we don't have a specific car selected in main test drive modal,
        // We leave car_id empty or handle it based on a dummy "general" booking logic
        // This avoids errors if Pocketbase car_id is not required.
      });
      alert("✅ Test Drive Requested Successfully!"); setShowTestDriveModal(false);
    } catch (error) { alert("Error: " + error.message); }
  };

  const handleDotScroll = (e, setDotFunc) => { const scrollLeft = e.target.scrollLeft; const itemWidth = 240 + 16; setDotFunc(Math.round(scrollLeft / itemWidth)); };
  const handleImageScroll = (e, carId) => { const scrollLeft = e.target.scrollLeft; const width = e.target.clientWidth; setImageDotIndex(prev => ({ ...prev, [carId]: Math.round(scrollLeft / width) })); };

  const filteredCars = useMemo(() => {
    let result = safeCarsArray.filter(car => car.status === 'Approved');

    if (listConfig.type === 'premium') result = result.filter(c => (Number(c.price) || 0) >= 800000);
    if (listConfig.type === 'budget') result = result.filter(c => (Number(c.price) || 0) < 500000);
    if (listConfig.type === 'new') {
      const oneMonthAgo = new Date(); oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
      result = result.filter(c => c.created && new Date(c.created) >= oneMonthAgo);
    }
    if (listConfig.type === 'brand' && listConfig.brand) result = result.filter(c => c.brand && c.brand.toLowerCase().includes(listConfig.brand.toLowerCase()));
    
    if (listConfig.type === 'bodyType' && listConfig.bodyType) result = result.filter(c => getVal(c.body_type) === listConfig.bodyType);
    
    if (listConfig.type === 'hot_deal') result = result.filter(c => c.hot_deal === true);
    if (listConfig.type === 'less_driven') result = result.filter(c => (Number(c.kilometers_driven) || 0) < 30000);
    if (listConfig.type === 'high_mileage') result = result.filter(c => (Number(c.mileage) || 0) >= 18);

    if (searchTerm && listConfig.type !== 'brand' && listConfig.type !== 'bodyType') {
      const lowerSearch = searchTerm.toLowerCase();
      result = result.filter(c => (c.brand && c.brand.toLowerCase().includes(lowerSearch)) || (c.model && c.model.toLowerCase().includes(lowerSearch)) );
    }
    
    result = result.filter(c => (Number(c.price) || 0) >= priceRange.min && (Number(c.price) || 0) <= priceRange.max);
    if (selectedBrandsFilter.length > 0) result = result.filter(c => c.brand && selectedBrandsFilter.includes(c.brand));
    if (selectedBodyTypeFilter.length > 0) result = result.filter(c => selectedBodyTypeFilter.includes(getVal(c.body_type)));
    if (fuelFilters.length > 0) result = result.filter(c => fuelFilters.includes(getVal(c.fuel_type)));
    if (transmissionFilters.length > 0) result = result.filter(c => transmissionFilters.includes(getVal(c.transmission)));
    if (ownerFilters.length > 0) result = result.filter(c => c.owner_type && ownerFilters.includes(c.owner_type));
    if (selectedCities.length > 0) result = result.filter(c => selectedCities.includes(getVal(c.city)));

    if (sortBy === 'Price - Low to High') result.sort((a, b) => (Number(a.price) || 0) - (Number(b.price) || 0));
    if (sortBy === 'Price - High to Low') result.sort((a, b) => (Number(b.price) || 0) - (Number(a.price) || 0));
    if (sortBy === 'KM Driven - Low to High') result.sort((a, b) => (Number(a.kilometers_driven) || 0) - (Number(b.kilometers_driven) || 0));
    if (sortBy === 'Newest First') result.sort((a, b) => new Date(b.created || 0) - new Date(a.created || 0));

    return result;
  }, [safeCarsArray, searchTerm, listConfig, priceRange, selectedBrandsFilter, selectedBodyTypeFilter, fuelFilters, transmissionFilters, ownerFilters, selectedCities, sortBy]);

  const recommendedCars = useMemo(() => safeCarsArray.filter(car => car.status === 'Approved').slice(0, 5), [safeCarsArray]); 
  const budgetCars = useMemo(() => safeCarsArray.filter(car => car.status === 'Approved' && (Number(car.price) || 0) < 500000).slice(0, 5), [safeCarsArray]);
  const soldCars = useMemo(() => safeCarsArray.filter(car => car.status === 'Sold').sort((a, b) => new Date(b.updated || 0) - new Date(a.updated || 0)).slice(0, 5), [safeCarsArray]);

  const renderCarCard = (car, currentImgIndex, showSoldBadge = false) => {
    const images = getImages(car.image);
    return (
      <div key={car.id} onClick={() => { setSelectedCar(car); setView('details'); }} className="shrink-0 w-[240px] bg-white rounded-[20px] shadow-sm border border-gray-100 snap-start overflow-hidden cursor-pointer relative hover:shadow-md transition-shadow">
        <div className="h-[140px] relative bg-gray-100 overflow-x-auto snap-x hide-scrollbar flex" onScroll={(e) => handleImageScroll(e, car.id)}>
          {images.length > 0 ? images.map((img, i) => ( <img key={i} src={`https://bahcarplaza.com/api/files/${car.collectionId}/${car.id}/${img}`} className="w-full h-full object-cover shrink-0 snap-start" alt="car" /> )) : <div className="w-full h-full flex items-center justify-center text-gray-300 font-bold">No Image</div>}
          {showSoldBadge && <div className="absolute inset-0 bg-black/40 flex items-center justify-center z-10 backdrop-blur-[1px]"><span className="bg-red-600 text-white font-black text-xl px-4 py-1.5 rounded-lg rotate-[-12deg] tracking-widest border-2 border-white shadow-lg uppercase">SOLD OUT</span></div>}
        </div>
        {!showSoldBadge && <button onClick={(e) => handleAddToWishlist(e, car.id)} className="absolute top-2 right-2 bg-white/80 backdrop-blur-sm p-1.5 rounded-full border-none shadow-sm text-xs z-10 hover:scale-110 transition-transform">❤️</button>}
        {images.length > 1 && (
          <div className="absolute top-[125px] left-1/2 -translate-x-1/2 flex gap-1 z-10 pointer-events-none">
            {images.map((_, i) => ( <div key={i} className={`h-1.5 rounded-full ${currentImgIndex === i ? 'w-3 bg-white' : 'w-1.5 bg-white/50'}`}></div> ))}
          </div>
        )}
        <div className="p-3">
          <h3 className="m-0 text-[#002f34] font-black text-[14px] truncate">{car.year || ''} {car.brand || 'Unknown'} {car.model || ''}</h3>
          <p className="m-0 text-gray-500 font-bold text-[9px] mt-1 flex gap-1 items-center flex-wrap">
            <span className="bg-gray-50 px-1.5 py-0.5 rounded border border-gray-100">{(car.kilometers_driven || 0).toLocaleString()} km</span>
            <span className="bg-gray-50 px-1.5 py-0.5 rounded border border-gray-100">{getVal(car.fuel_type) || '-'}</span>
            <span className="bg-gray-50 px-1.5 py-0.5 rounded border border-gray-100">{getVal(car.transmission) || '-'}</span>
          </p>
          <div className="mt-3 flex justify-between items-center border-t border-gray-50 pt-2">
            <div>
              <span className={`font-black text-[16px] ${showSoldBadge ? 'text-gray-400' : 'text-[#002f34]'}`}>₹{(car.price || 0).toLocaleString()}</span>
              {!showSoldBadge && <p className="m-0 text-gray-400 font-bold text-[8px] mt-0.5">EMI ₹{calculateEMI(car.price)}/m</p>}
            </div>
            {!showSoldBadge && <button onClick={(e) => handleBuyNow(e, car)} className="bg-[#002f34] text-white px-3 py-1.5 rounded-lg font-black text-[9px] uppercase border-none shadow-sm active:scale-95 transition-transform">Buy</button>}
          </div>
        </div>
      </div>
    );
  };

  // ==========================================
  // 🚨 MAIN VIEW 🚨
  // ==========================================
  if (subView === 'main') {
    return (
      <div className="min-h-screen bg-[#f4f7f6] pb-6 font-sans">
        <style>{`.hide-scrollbar::-webkit-scrollbar { display: none; } .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }`}</style>
        
        <div className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#012b72] shadow-md py-3' : 'bg-[#012b72] pt-4 pb-4 shadow-none rounded-b-[1.5rem]'}`}>
          <div className="px-4">
            
            <div className={`flex items-center gap-2 cursor-pointer overflow-hidden transition-all duration-300 ${isScrolled ? 'max-h-0 opacity-0 mb-0' : 'max-h-[50px] opacity-100 mb-4'}`} onClick={handleCustomBack}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.4-1.7-1-2.2l-3.2-2.7a3 3 0 0 0-1.9-.9H5a3 3 0 0 0-1.9.9L0 10.8c-.6.5-1 1.3-1 2.2v3c0 .6.4 1 1 1h2"></path>
                <circle cx="16.5" cy="17.5" r="2.5"></circle>
                <circle cx="5.5" cy="17.5" r="2.5"></circle>
              </svg>
              <h1 className="m-0 text-white font-black text-[20px] tracking-tight">Bah!<span className="text-[#ef5e33]">CarPlaza</span></h1>
            </div>
            
            <div className="bg-white rounded-full flex items-center px-4 py-2.5 shadow-inner">
              <button onClick={handleCustomBack} className="bg-transparent border-none p-0 flex items-center justify-center cursor-pointer mr-3">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#002f34" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
              </button>
              <input 
                type="text" 
                placeholder="Search brands, models..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="flex-1 bg-transparent border-none outline-none font-bold text-[#002f34] text-[13px] placeholder-gray-400"
              />
              {searchTerm && (
                <button onClick={() => openListView('all', '', '', `Search: ${searchTerm}`)} className="bg-transparent border-none p-0 flex items-center justify-center cursor-pointer ml-2">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                </button>
              )}
            </div>
          </div>
        </div>

        <div className={`transition-all duration-300 ${isScrolled ? 'h-[75px]' : 'h-[130px]'}`}></div>

        <div className="px-4 mt-2">
          
          <div className="grid grid-cols-2 gap-3 mb-8">
            <div onClick={() => openListView('all', '', '', 'All Cars')} className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-4 shadow-sm border border-blue-200 relative overflow-hidden cursor-pointer h-[100px] flex flex-col justify-center">
               <h3 className="m-0 text-[#002f34] font-black text-[14px] z-10 relative">All Cars</h3>
               <p className="m-0 text-blue-600 text-[9px] font-bold mt-1 z-10 relative uppercase tracking-wider">Best prices</p>
               <svg className="absolute -bottom-3 -right-2 w-20 h-20 opacity-30 drop-shadow-md text-blue-500" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M18.92 5.01C18.72 4.42 18.16 4 17.5 4H6.5C5.84 4 5.28 4.42 5.08 5.01L3 11V20C3 20.55 3.45 21 4 21H5C5.55 21 6 20.55 6 20V19H18V20C18 20.55 18.45 21 19 21H20C20.55 21 21 20.55 21 20V11L18.92 5.01ZM6.85 5.5H17.15L18.22 8.5H5.78L6.85 5.5ZM19 17H5V10.12L5.4 9H18.6L19 10.12V17ZM7.5 14C8.33 14 9 13.33 9 12.5C9 11.67 8.33 11 7.5 11C6.67 11 6 11.67 6 12.5C6 13.33 6.67 14 7.5 14ZM16.5 14C17.33 14 18 13.33 18 12.5C18 11.67 17.33 11 16.5 11C15.67 11 15 11.67 15 12.5C15 13.33 15.67 14 16.5 14Z"/></svg>
            </div>
            
            <div onClick={() => openListView('new', '', '', 'New Arrivals')} className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-4 shadow-sm border border-purple-200 relative overflow-hidden cursor-pointer h-[100px] flex flex-col justify-center">
               <h3 className="m-0 text-[#002f34] font-black text-[14px] z-10 relative">New Arrivals</h3>
               <p className="m-0 text-purple-600 text-[9px] font-bold mt-1 z-10 relative uppercase tracking-wider">Just added</p>
               <svg className="absolute -bottom-2 -right-1 w-16 h-16 opacity-30 drop-shadow-md text-purple-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
            </div>
            
            <div onClick={() => openListView('premium', '', '', 'Premium Cars')} className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-4 shadow-sm border border-orange-200 relative overflow-hidden cursor-pointer h-[100px] flex flex-col justify-center">
               <h3 className="m-0 text-[#002f34] font-black text-[14px] z-10 relative">Premium</h3>
               <p className="m-0 text-orange-600 text-[9px] font-bold mt-1 z-10 relative uppercase tracking-wider">Above ₹8 Lakhs</p>
               <svg className="absolute -bottom-2 -right-1 w-16 h-16 opacity-30 drop-shadow-md text-orange-500" viewBox="0 0 24 24" fill="currentColor"><path d="M12.1 2.5a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 2 8.2v7.5a2 2 0 0 0 1 1.7l7 4a2 2 0 0 0 2 0l7-4a2 2 0 0 0 1-1.7V8.2a2 2 0 0 0-1-1.7l-7-4zm-1 1.8l6 3.4-6 3.4-6-3.4 6-3.4zm-7 5.2l6 3.4v6.8l-6-3.4v-6.8zm14 6.8l-6 3.4v-6.8l6-3.4v6.8z"/></svg>
            </div>
            
            <div onClick={openTestDriveModal} className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl p-4 shadow-sm border border-teal-200 relative overflow-hidden cursor-pointer h-[100px] flex flex-col justify-center">
               <h3 className="m-0 text-[#002f34] font-black text-[14px] z-10 relative">Test Drive</h3>
               <p className="m-0 text-teal-600 text-[9px] font-bold mt-1 z-10 relative uppercase tracking-wider">Book at home</p>
               <svg className="absolute -bottom-3 -right-1 w-[70px] h-[70px] opacity-30 drop-shadow-md text-teal-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></svg>
            </div>
          </div>

          <div className="mb-8">
            <div className="flex justify-between items-end mb-4 px-1">
              <h2 className="text-[16px] font-black text-[#002f34] m-0">Explore by brand</h2>
              <span onClick={() => setShowBrandsSheet(true)} className="text-[#ef5e33] font-black text-[10px] uppercase cursor-pointer">View All</span>
            </div>
            <div className="flex overflow-x-auto gap-4 pb-2 hide-scrollbar snap-x">
              {ALL_BRANDS.slice(0, 8).map(brand => (
                <div key={brand} onClick={() => openListView('brand', brand, '', `${brand} Cars`)} className="flex flex-col items-center gap-2 shrink-0 snap-center cursor-pointer">
                  <div className="w-[65px] h-[65px] bg-white rounded-full shadow-sm border border-gray-100 flex items-center justify-center p-3 hover:border-[#ef5e33] transition-colors">
                    {BRAND_LOGOS[brand] ? <img src={BRAND_LOGOS[brand]} alt={brand} className="w-full h-full object-contain mix-blend-multiply" /> : <span className="font-black text-xl text-gray-300">{(brand || "U").charAt(0).toUpperCase()}</span>}
                  </div>
                  <span className="text-[10px] font-black text-[#002f34]">{brand.split(' ')[0]}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mb-8">
            <div className="flex justify-between items-end mb-4 px-1">
              <h2 className="text-[16px] font-black text-[#002f34] m-0">Explore by Body Type</h2>
            </div>
            <div className="flex overflow-x-auto gap-4 pb-2 hide-scrollbar snap-x">
              {BODY_TYPES.map(type => (
                <div key={type.name} onClick={() => openListView('bodyType', '', type.name, `${type.name} Cars`)} className="flex flex-col items-center gap-2 shrink-0 snap-center cursor-pointer">
                  <div className="w-[65px] h-[65px] bg-[#f9fafb] rounded-[18px] shadow-sm border border-gray-200 flex items-center justify-center p-3 hover:border-[#002f34] hover:bg-white transition-all">
                    <span className="w-full h-full flex items-center justify-center drop-shadow-sm">{type.icon}</span>
                  </div>
                  <span className="text-[10px] font-black text-[#002f34] tracking-wide uppercase">{type.name}</span>
                </div>
              ))}
            </div>
          </div>

          {recommendedCars.length > 0 && (
            <div className="mb-8">
              <div className="flex justify-between items-end mb-4 px-1">
                <h2 className="text-[16px] font-black text-[#002f34] m-0">Recommended for you</h2>
                <span onClick={() => openListView('all', '', '', 'All Cars')} className="text-[#ef5e33] font-black text-[10px] uppercase cursor-pointer">View All</span>
              </div>
              <div onScroll={(e) => handleDotScroll(e, setActiveRecDot)} className="flex overflow-x-auto gap-4 pb-2 hide-scrollbar snap-x">
                {recommendedCars.map((car) => renderCarCard(car, imageDotIndex[car.id] || 0))}
              </div>
              <div className="flex justify-center gap-1.5 mt-2">
                {recommendedCars.map((_, i) => ( <div key={i} className={`h-1.5 rounded-full transition-all duration-300 ${activeRecDot === i ? 'w-5 bg-[#002f34]' : 'w-1.5 bg-gray-300'}`}></div> ))}
              </div>
            </div>
          )}

          {budgetCars.length > 0 && (
            <div className="mb-8">
              <div className="flex justify-between items-end mb-4 px-1">
                <div>
                  <h2 className="text-[16px] font-black text-[#002f34] m-0">Budget Cars</h2>
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest m-0 mt-0.5">Under ₹5 Lakhs</p>
                </div>
                <span onClick={() => openListView('budget', '', '', 'Budget Cars')} className="text-[#ef5e33] font-black text-[10px] uppercase cursor-pointer">View All</span>
              </div>
              <div onScroll={(e) => handleDotScroll(e, setActiveBudgetDot)} className="flex overflow-x-auto gap-4 pb-2 hide-scrollbar snap-x">
                {budgetCars.map((car) => renderCarCard(car, imageDotIndex[car.id] || 0))}
              </div>
              <div className="flex justify-center gap-1.5 mt-2">
                {budgetCars.map((_, i) => ( <div key={i} className={`h-1.5 rounded-full transition-all duration-300 ${activeBudgetDot === i ? 'w-5 bg-[#002f34]' : 'w-1.5 bg-gray-300'}`}></div> ))}
              </div>
            </div>
          )}

          {soldCars.length > 0 && (
            <div className="mb-4">
              <div className="flex justify-between items-end mb-4 px-1">
                <h2 className="text-[16px] font-black text-[#002f34] m-0">Recently Sold Out</h2>
              </div>
              <div onScroll={(e) => handleDotScroll(e, setActiveSoldDot)} className="flex overflow-x-auto gap-4 pb-2 hide-scrollbar snap-x grayscale-[0.3]">
                {soldCars.map((car) => renderCarCard(car, imageDotIndex[car.id] || 0, true))}
              </div>
              <div className="flex justify-center gap-1.5 mt-2">
                {soldCars.map((_, i) => ( <div key={i} className={`h-1.5 rounded-full transition-all duration-300 ${activeSoldDot === i ? 'w-5 bg-[#002f34]' : 'w-1.5 bg-gray-300'}`}></div> ))}
              </div>
            </div>
          )}

        </div>

        {/* Modals */}
        {showBrandsSheet && (
          <div className="fixed inset-0 bg-[#002f34]/60 z-[9999] flex flex-col justify-end backdrop-blur-sm">
            <div className="absolute inset-0" onClick={() => setShowBrandsSheet(false)}></div>
            <div className="bg-white w-full rounded-t-[30px] p-6 shadow-2xl relative flex flex-col max-h-[85vh] animate-slideUp">
              <div className="flex justify-between items-center mb-6">
                 <h3 className="font-black text-xl text-[#002f34] m-0 uppercase">All Brands</h3>
                 <button onClick={() => setShowBrandsSheet(false)} className="bg-gray-100 border-none w-8 h-8 rounded-full font-bold cursor-pointer">✕</button>
              </div>
              <div className="overflow-y-auto pb-6 hide-scrollbar">
                 <div className="grid grid-cols-3 gap-4">
                    {ALL_BRANDS.map((brand) => (
                      <div key={brand} onClick={() => { setShowBrandsSheet(false); openListView('brand', brand, '', `${brand} Cars`); }} className="bg-gray-50 rounded-xl p-3 flex flex-col items-center justify-center border border-gray-100 shadow-sm cursor-pointer active:scale-95 transition-transform">
                        {BRAND_LOGOS[brand] ? <img src={BRAND_LOGOS[brand]} alt={brand} className="w-full h-10 object-contain mix-blend-multiply mb-2" /> : <span className="text-xl font-black text-gray-400 mb-2">{(brand || "U").charAt(0).toUpperCase()}</span>}
                        <p className="text-[10px] font-black text-[#002f34] m-0 text-center">{brand}</p>
                      </div>
                    ))}
                 </div>
              </div>
            </div>
          </div>
        )}

        {showTestDriveModal && (
          <div className="fixed inset-0 bg-[#002f34]/80 z-[9999] flex items-center justify-center p-4 backdrop-blur-sm">
            <div className="bg-white w-full max-w-[500px] rounded-[30px] p-6 shadow-2xl animate-slideUp">
               <div className="flex justify-between items-center mb-6">
                  <div>
                    <h2 className="font-black text-2xl text-[#002f34] m-0 uppercase">Book Test Drive</h2>
                    <p className="text-gray-500 font-bold text-xs m-0 mt-1">We will bring the car to your home!</p>
                  </div>
                  <button onClick={() => setShowTestDriveModal(false)} className="bg-gray-100 border-none font-bold cursor-pointer text-black w-8 h-8 rounded-full flex items-center justify-center">✕</button>
               </div>
               <form onSubmit={handleTestDriveSubmit} className="flex flex-col gap-4">
                  <input required type="text" placeholder="Full Name" value={testDriveData.full_name} onChange={(e) => setTestDriveData({...testDriveData, full_name: e.target.value})} className="p-3.5 rounded-xl border border-gray-200 bg-gray-50 font-bold text-sm outline-none" />
                  <input required type="number" placeholder="Phone Number" value={testDriveData.phone} onChange={(e) => setTestDriveData({...testDriveData, phone: e.target.value})} className="p-3.5 rounded-xl border border-gray-200 bg-gray-50 font-bold text-sm outline-none" />
                  <input required type="datetime-local" onChange={(e) => setTestDriveData({...testDriveData, booking_date: e.target.value})} className="p-3.5 rounded-xl border border-gray-200 bg-gray-50 font-bold text-sm outline-none" />
                  <textarea placeholder="Any specific car model? (Optional)" onChange={(e) => setTestDriveData({...testDriveData, message: e.target.value})} className="p-3.5 rounded-xl border border-gray-200 bg-gray-50 font-bold text-sm outline-none h-[80px] resize-none" />
                  <button type="submit" className="p-4 bg-[#ef5e33] text-white border-none rounded-xl font-black uppercase shadow-lg active:scale-95 transition-transform">Confirm Booking ✓</button>
               </form>
            </div>
          </div>
        )}

      </div>
    );
  }

  // ==========================================
  // 🚨 LIST VIEW (With Filter & Sort) 🚨
  // ==========================================
  if (subView === 'list') {
    return (
      <div className="min-h-screen bg-[#f4f7f6] pb-[70px] font-sans flex flex-col">
        
        <div className="bg-[#012b72] p-4 flex items-center justify-between sticky top-0 z-30 shadow-md">
          <div className="flex items-center gap-3">
            <button onClick={handleCustomBack} className="bg-white/20 w-8 h-8 rounded-full border-none text-white text-lg flex items-center justify-center font-bold cursor-pointer hover:bg-white/30 transition-colors">←</button>
            <div>
              <h2 className="m-0 font-black text-[15px] text-white uppercase tracking-wide">{listConfig.title}</h2>
              <p className="m-0 text-[9px] font-bold text-gray-200 uppercase tracking-widest">{filteredCars.length} Cars Available</p>
            </div>
          </div>
          <button onClick={handleCustomBack} className="bg-white/20 w-8 h-8 rounded-full flex items-center justify-center border-none text-sm cursor-pointer hover:bg-white/30 transition-colors">
             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          </button>
        </div>

        {/* 🚨 Sticky Top Bar for Body Types 🚨 */}
        {listConfig.type === 'bodyType' && (
          <div className="bg-white border-b border-gray-100 px-3 py-3 flex overflow-x-auto hide-scrollbar gap-2 sticky top-[60px] z-20 shadow-sm">
            <button 
                onClick={() => setListConfig({...listConfig, bodyType: '', title: 'All Cars'})}
                className={`px-5 py-2 rounded-full border-none font-black text-[12px] whitespace-nowrap transition-colors shadow-sm ${!listConfig.bodyType ? 'bg-[#ef5e33] text-white' : 'bg-gray-100 text-gray-500'}`}
            >
                All
            </button>
            {BODY_TYPES.map(type => (
                <button 
                    key={type.name}
                    onClick={() => setListConfig({...listConfig, bodyType: type.name, title: `${type.name} Cars`})}
                    className={`px-5 py-2 rounded-full border-none font-black text-[12px] whitespace-nowrap transition-colors shadow-sm flex items-center gap-1 ${listConfig.bodyType === type.name ? 'bg-[#ef5e33] text-white' : 'bg-gray-100 text-gray-500'}`}
                >
                    {type.name}
                </button>
            ))}
          </div>
        )}

        <div className="p-4 flex-1 overflow-y-auto flex flex-col gap-4">
          {filteredCars.length > 0 ? filteredCars.map(car => {
            const images = getImages(car.image);
            const currentImgIndex = imageDotIndex[car.id] || 0;

            return (
              <div key={car.id} onClick={() => { setSelectedCar(car); setView('details'); }} className="bg-white rounded-[20px] shadow-sm border border-gray-100 overflow-hidden cursor-pointer relative pb-3 hover:shadow-md transition-shadow">
                
                <div className="h-[200px] relative bg-gray-100 flex overflow-x-auto snap-x hide-scrollbar" onScroll={(e) => handleImageScroll(e, car.id)}>
                  {images.length > 0 ? images.map((img, i) => (
                    <img key={i} src={`https://bahcarplaza.com/api/files/${car.collectionId}/${car.id}/${img}`} className="w-full h-full object-cover shrink-0 snap-start" alt="car" />
                  )) : <div className="w-full h-full flex items-center justify-center text-gray-300 font-bold">No Image</div>}
                </div>
                
                <button onClick={(e) => handleAddToWishlist(e, car.id)} className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm w-9 h-9 flex items-center justify-center rounded-full border-none shadow-sm text-lg z-10 hover:scale-110 transition-transform">🤍</button>
                
                {images.length > 1 && (
                  <div className="absolute top-[185px] left-1/2 -translate-x-1/2 flex gap-1 z-10 pointer-events-none">
                    {images.map((_, i) => (
                        <div key={i} className={`h-1.5 rounded-full shadow-sm ${currentImgIndex === i ? 'w-4 bg-white' : 'w-1.5 bg-white/60'}`}></div>
                    ))}
                  </div>
                )}

                <div className="px-4 pt-3">
                  <div className="flex justify-between items-start mb-2">
                    <div className="flex-1">
                      <h3 className="m-0 text-[#002f34] font-black text-[16px] leading-tight">{car.year || ''} {car.brand || 'Unknown'} <br/>{car.model || ''}</h3>
                    </div>
                    <div className="text-right flex-shrink-0 ml-3">
                      <h3 className="m-0 text-[#002f34] font-black text-[18px]">₹{(car.price || 0).toLocaleString()}</h3>
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-1.5 mb-3">
                    <span className="bg-gray-50 text-gray-600 font-bold text-[9px] px-2 py-1 rounded-md uppercase border border-gray-100">{(car.kilometers_driven || 0).toLocaleString()} km</span>
                    <span className="bg-gray-50 text-gray-600 font-bold text-[9px] px-2 py-1 rounded-md uppercase border border-gray-100">{getVal(car.fuel_type) || '-'}</span>
                    <span className="bg-gray-50 text-gray-600 font-bold text-[9px] px-2 py-1 rounded-md uppercase border border-gray-100">{getVal(car.transmission) || '-'}</span>
                    <span className="bg-gray-50 text-gray-600 font-bold text-[9px] px-2 py-1 rounded-md uppercase border border-gray-100">{getVal(car.city) || '-'}</span>
                  </div>

                  <div className="flex justify-between items-center border-t border-gray-50 pt-3">
                     <p className="m-0 text-gray-400 font-bold text-[10px]">EMI Starts @ ₹{calculateEMI(car.price)}/m</p>
                     <button onClick={(e) => handleBuyNow(e, car)} className="bg-[#002f34] text-white px-5 py-2 rounded-xl font-black text-[10px] uppercase border-none shadow-sm active:scale-95 transition-transform">Buy Now</button>
                  </div>
                </div>
              </div>
            );
          }) : (
            <div className="text-center py-20 flex flex-col items-center justify-center">
              <span className="text-6xl opacity-20 block mb-4 grayscale">🚙</span>
              <h3 className="text-[#002f34] font-black text-lg m-0 uppercase tracking-wide">No Cars Found</h3>
              <p className="text-gray-400 font-bold text-xs mt-2 max-w-[200px]">We couldn't find any cars matching your criteria.</p>
              <button onClick={() => { setPriceRange({min:0, max:7000000}); setSelectedBrandsFilter([]); setSelectedBodyTypeFilter([]); setKmDrivenFilters([]); setFuelFilters([]); setTransmissionFilters([]); setOwnerFilters([]); setSelectedCities([]); }} className="mt-4 px-6 py-2 bg-[#ef5e33] text-white font-black text-xs uppercase rounded-lg border-none shadow-sm cursor-pointer">Clear Filters</button>
            </div>
          )}
        </div>

        {/* Sticky Filter & Sort Bar */}
        <div className="fixed bottom-[65px] left-0 right-0 bg-[#002f34] flex shadow-[0_-5px_20px_rgba(0,0,0,0.15)] z-40 mx-4 mb-4 rounded-2xl overflow-hidden p-1">
          <button onClick={() => setShowSortSheet(true)} className="flex-1 py-3 flex items-center justify-center gap-2 bg-transparent border-none border-r border-white/20 font-black text-[11px] text-white uppercase cursor-pointer">
            <span className="text-sm">⇅</span> Sort By
          </button>
          <button onClick={() => setShowFilterSheet(true)} className="flex-1 py-3 flex items-center justify-center gap-2 bg-transparent border-none font-black text-[11px] text-white uppercase cursor-pointer relative">
            <span className="text-sm">⧸</span> Filter
            {(priceRange.min > 0 || priceRange.max < 7000000 || selectedBrandsFilter.length > 0 || selectedBodyTypeFilter.length > 0 || kmDrivenFilters.length > 0 || fuelFilters.length > 0 || ownerFilters.length > 0 || selectedCities.length > 0) && (
              <span className="absolute top-2 right-6 w-2 h-2 rounded-full bg-[#ef5e33] border border-[#002f34]"></span>
            )}
          </button>
        </div>

        {/* Sort Modal */}
        {showSortSheet && (
          <div className="fixed inset-0 bg-[#002f34]/60 z-[9999] flex flex-col justify-end backdrop-blur-sm">
            <div className="absolute inset-0" onClick={() => setShowSortSheet(false)}></div>
            <div className="bg-white w-full rounded-t-[30px] p-6 shadow-2xl relative animate-slideUp">
              <div className="flex justify-between items-center mb-4">
                 <h3 className="font-black text-lg text-[#002f34] m-0 uppercase">Sort By</h3>
                 <button onClick={() => setShowSortSheet(false)} className="bg-gray-100 border-none w-8 h-8 rounded-full font-bold cursor-pointer">✕</button>
              </div>
              <div className="flex flex-col gap-2">
                {['Relevance', 'Price - Low to High', 'Price - High to Low', 'KM Driven - Low to High', 'Newest First'].map(sortOption => (
                  <button 
                    key={sortOption}
                    onClick={() => { setSortBy(sortOption); setShowSortSheet(false); }}
                    className={`py-4 px-5 text-left rounded-xl border-none font-black text-[13px] cursor-pointer transition-colors uppercase tracking-wide ${sortBy === sortOption ? 'bg-[#002f34] text-white shadow-md' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'}`}
                  >
                    {sortOption}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Filter Modal */}
        {showFilterSheet && (
          <div className="fixed inset-0 bg-[#002f34]/60 z-[9999] flex flex-col justify-end backdrop-blur-sm">
            <div className="absolute inset-0" onClick={() => setShowFilterSheet(false)}></div>
            <div className="bg-white w-full rounded-t-[30px] shadow-2xl relative flex flex-col h-[85vh] animate-slideUp">
              <div className="flex justify-between items-center p-5 border-b border-gray-100">
                 <h3 className="font-black text-lg text-[#002f34] m-0 uppercase">All Filters</h3>
                 <button onClick={() => { 
                   setPriceRange({min:0, max:7000000}); setSelectedBrandsFilter([]); setSelectedBodyTypeFilter([]); setKmDrivenFilters([]); setFuelFilters([]); setTransmissionFilters([]); setOwnerFilters([]); setSelectedCities([]);
                 }} className="bg-transparent border-none text-[#ef5e33] font-black text-[11px] uppercase cursor-pointer hover:underline">Reset</button>
              </div>
              
              <div className="flex-1 overflow-y-auto p-5 pb-[100px] flex flex-col gap-8 hide-scrollbar">
                
                {/* Budget */}
                <div>
                  <h4 className="font-black text-[#002f34] text-[12px] uppercase mb-4 tracking-widest">Budget (₹)</h4>
                  <div className="flex justify-between text-[11px] font-black text-[#ef5e33] mb-2">
                    <span>₹{priceRange.min.toLocaleString()}</span>
                    <span>₹{priceRange.max.toLocaleString()}</span>
                  </div>
                  <input type="range" min="0" max="7000000" step="50000" value={priceRange.max} onChange={(e) => setPriceRange({...priceRange, max: parseInt(e.target.value)})} className="w-full accent-[#ef5e33]" />
                </div>

                {/* Brands */}
                {ALL_BRANDS.length > 0 && (
                  <div>
                    <h4 className="font-black text-[#002f34] text-[12px] uppercase mb-4 tracking-widest">Brands</h4>
                    <div className="flex flex-wrap gap-2">
                      {ALL_BRANDS.map(b => (
                        <button key={b} onClick={() => setSelectedBrandsFilter(prev => prev.includes(b) ? prev.filter(x => x !== b) : [...prev, b])} 
                          className={`px-4 py-2 rounded-full border-2 font-bold text-[11px] cursor-pointer transition-all ${selectedBrandsFilter.includes(b) ? 'border-[#002f34] bg-[#002f34] text-white shadow-sm' : 'border-gray-200 bg-white text-gray-500 hover:border-gray-300'}`}>
                          {b}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Body Type Filter */}
                {BODY_TYPES.length > 0 && (
                  <div>
                    <h4 className="font-black text-[#002f34] text-[12px] uppercase mb-4 tracking-widest">Body Type</h4>
                    <div className="flex flex-wrap gap-2">
                      {BODY_TYPES.map(type => (
                        <button key={type.name} onClick={() => setSelectedBodyTypeFilter(prev => prev.includes(type.name) ? prev.filter(x => x !== type.name) : [...prev, type.name])} 
                          className={`px-4 py-2 rounded-full border-2 font-bold text-[11px] cursor-pointer transition-all flex items-center gap-2 ${selectedBodyTypeFilter.includes(type.name) ? 'border-[#002f34] bg-[#002f34] text-white shadow-sm' : 'border-gray-200 bg-white text-gray-500 hover:border-gray-300'}`}>
                          <div className="w-6 h-4">{type.icon}</div> {type.name}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Dynamic Cities */}
                {dynamicCities.length > 0 && (
                  <div>
                    <h4 className="font-black text-[#002f34] text-[12px] uppercase mb-4 tracking-widest">City</h4>
                    <div className="flex flex-wrap gap-2">
                      {dynamicCities.map(c => (
                        <button key={c} onClick={() => setSelectedCities(prev => prev.includes(c) ? prev.filter(x => x !== c) : [...prev, c])} 
                          className={`px-4 py-2 rounded-full border-2 font-bold text-[11px] cursor-pointer transition-all ${selectedCities.includes(c) ? 'border-[#002f34] bg-[#002f34] text-white shadow-sm' : 'border-gray-200 bg-white text-gray-500 hover:border-gray-300'}`}>
                          {c}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Fuel */}
                {dynamicFuels.length > 0 && (
                  <div>
                    <h4 className="font-black text-[#002f34] text-[12px] uppercase mb-4 tracking-widest">Fuel Type</h4>
                    <div className="flex flex-wrap gap-2">
                      {dynamicFuels.map(f => (
                        <button key={f} onClick={() => setFuelFilters(prev => prev.includes(f) ? prev.filter(x => x !== f) : [...prev, f])} 
                          className={`px-4 py-2 rounded-full border-2 font-bold text-[11px] cursor-pointer transition-all ${fuelFilters.includes(f) ? 'border-[#002f34] bg-[#002f34] text-white shadow-sm' : 'border-gray-200 bg-white text-gray-500 hover:border-gray-300'}`}>
                          {f}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Transmission */}
                {dynamicTransmissions.length > 0 && (
                  <div>
                    <h4 className="font-black text-[#002f34] text-[12px] uppercase mb-4 tracking-widest">Transmission</h4>
                    <div className="flex flex-wrap gap-2">
                      {dynamicTransmissions.map(t => (
                        <button key={t} onClick={() => setTransmissionFilters(prev => prev.includes(t) ? prev.filter(x => x !== t) : [...prev, t])} 
                          className={`px-4 py-2 rounded-full border-2 font-bold text-[11px] cursor-pointer transition-all ${transmissionFilters.includes(t) ? 'border-[#002f34] bg-[#002f34] text-white shadow-sm' : 'border-gray-200 bg-white text-gray-500 hover:border-gray-300'}`}>
                          {t}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Owner */}
                {dynamicOwners.length > 0 && (
                  <div>
                    <h4 className="font-black text-[#002f34] text-[12px] uppercase mb-4 tracking-widest">Owner</h4>
                    <div className="flex flex-wrap gap-2">
                      {dynamicOwners.map(o => (
                        <button key={o} onClick={() => setOwnerFilters(prev => prev.includes(o) ? prev.filter(x => x !== o) : [...prev, o])} 
                          className={`px-4 py-2 rounded-full border-2 font-bold text-[11px] cursor-pointer transition-all ${ownerFilters.includes(o) ? 'border-[#002f34] bg-[#002f34] text-white shadow-sm' : 'border-gray-200 bg-white text-gray-500 hover:border-gray-300'}`}>
                          {o}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* KM Driven */}
                <div>
                  <h4 className="font-black text-[#002f34] text-[12px] uppercase mb-4 tracking-widest">Kms Driven</h4>
                  <div className="flex flex-col gap-3">
                    {[{l:'Under 10,000 km', v:'10000'}, {l:'10,000 - 30,000 km', v:'30000'}, {l:'30,000 - 70,000 km', v:'70000'}, {l:'Above 70,000 km', v:'120000'}].map(km => (
                      <label key={km.v} className="flex items-center gap-3 font-bold text-[12px] text-gray-600 cursor-pointer group">
                        <div className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-colors ${kmDrivenFilters.includes(km.v) ? 'bg-[#ef5e33] border-[#ef5e33]' : 'border-gray-300 group-hover:border-[#ef5e33]'}`}>
                           {kmDrivenFilters.includes(km.v) && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>}
                        </div>
                        <input type="checkbox" checked={kmDrivenFilters.includes(km.v)} onChange={(e) => setKmDrivenFilters(prev => e.target.checked ? [...prev, km.v] : prev.filter(x => x !== km.v))} className="hidden" />
                        <span className={`${kmDrivenFilters.includes(km.v) ? 'text-[#002f34]' : ''}`}>{km.l}</span>
                      </label>
                    ))}
                  </div>
                </div>

              </div>

              <div className="absolute bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-100 shadow-[0_-10px_20px_rgba(0,0,0,0.05)] z-10">
                <button onClick={() => setShowFilterSheet(false)} className="w-full py-4 bg-[#ef5e33] text-white font-black text-[13px] uppercase tracking-wide rounded-xl border-none shadow-lg active:scale-95 transition-transform cursor-pointer">
                  Apply Filters ({filteredCars.length} Cars)
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    );
  }

  return null;
}

export default MobileBuyCar;